export default "__VITE_ASSET__C2lh$n2J__"